import React, { useCallback } from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { BackButton } from '~/components/BackButton'
import { PropsWithWizard } from '~/components/CreateAccountWizard/CreateAccountWizard'

type BaseHeaderProps = {
  removeSteps?: boolean,
  handleBack?: () => void,
  manualCurrentPage?: number
}

export type HeaderProps = PropsWithWizard<BaseHeaderProps>

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: mutualTheme.spacing(5),
    [mutualTheme.breakpoints.down('md')]: {
      marginBottom: mutualTheme.spacing(2),
      padding: mutualTheme.spacing(1)
    }
  },
  stepCounter: {
    color: mutualTheme.palette.textGray3.main
  }
})

export const Header: React.FC<HeaderProps> = (props) => {
  const { currentPage, handleBack, manualCurrentPage, removeSteps } = props

  const classes = useStyles()

  const handleGoBack = useCallback(() => {
    handleBack && handleBack()
  }, [handleBack])

  return (
    <Box className={classes.container}>
      {handleBack
        ? <BackButton onBackButtonClick={() => handleGoBack()} />
        : <Box></Box>
      }
      {!removeSteps && <Typography className={classes.stepCounter}>Etapa {manualCurrentPage || currentPage + 1} de 5</Typography>}
    </Box>
  )
}
